import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default ImmutablePropTypes.mapContains({
  id: PropTypes.number.isRequired,
  providerURI: PropTypes.string.isRequired,
  providerName: PropTypes.string,
  contents: PropTypes.string.isRequired,
  source: PropTypes.string,
  reviewLink: PropTypes.string,
  reviewDate: PropTypes.string,
  fullDetailsURI: PropTypes.string
});
